var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.1172C12.2344 13.7852 8.96484 11.0781 8.96484 7.49219C8.96484 5.41797 10.0547 3.51953 11.8477 2.5C12.7617 1.97266 12.5508 0.601562 11.4961 0.425781C11.0391 0.320312 10.3008 0.285156 9.84375 0.25C4.88672 0.25 0.84375 4.29297 0.84375 9.25C0.84375 14.2422 4.88672 18.25 9.84375 18.25C12.6211 18.25 15.1875 17.0195 16.8398 14.9453C17.5078 14.1016 16.8047 12.9414 15.75 13.1172ZM9.84375 17.125C5.51953 17.125 1.96875 13.6094 1.96875 9.25C1.96875 4.92578 5.51953 1.375 9.84375 1.375C10.3359 1.375 10.8281 1.44531 11.2852 1.51562C9.21094 2.71094 7.83984 4.92578 7.83984 7.49219C7.83984 11.8164 11.7422 15.0156 15.9609 14.2422C14.5195 16 12.3398 17.125 9.84375 17.125Z",
    fill: "#A270F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.839f1c7cf89c4e9f5ae3d5bd6c760e4e.svg";
export { ForwardRef as ReactComponent };